import request from "@/utils/request";  //导入封装请求的js文件

// 获取图形验证码
export function getCodeImg() {
  return request({
    url: "/loginApi/user/captchaImage",
    method: "get"
  });
}

export function getUserLoginPhoneCode(params) {
  return request({
    url: "/loginApi/user/getUserLoginPhoneCode",  //接口路径
    method: "get",  //接口方法
    params  //接口参数
  });
}

export function accountQQLogin(data) {
  return request({
    url: "/loginApi/user/accountQQLogin",  //接口路径
    method: "post",  //接口方法
    data  //接口参数
  });
}

export function getWechatQrCode() {
  return request({
    url: "/loginApi/user/getWechatQrCode",  //接口路径
    method: "post"
  });
}

export function accountPwdRegister(data) {
  return request({
    url: "/loginApi/user/accountPwdRegister",  //接口路径
    method: "post",  //接口方法
		data
  });
}

export function accountPwdLogin(data) {
  return request({
    url: "/loginApi/user/accountPwdLogin",  //接口路径
    method: "post",  //接口方法
		data
  });
}

export function accountCodeLogin(data) {
  return request({
    url: "/loginApi/user/accountCodeLogin",  //接口路径
    method: "post",  //接口方法
    data  //接口参数
  });
}

export function wxCallBack(code) {
  return request({
    url: "/loginApi/user/wxCallBack?code="+code,  //接口路径
    method: "post",  //接口方法
  });
}

export function getCurrentUserInfo() {
  return request({
    url: "/loginApi/user/getCurrentUserInfo",  //接口路径
    method: "get",  //接口方法
  });
}

export function layout() {
  return request({
    url: "/loginApi/user/layout",  //接口路径
    method: "get",  //接口方法
  });
}

// 找回密码
export function PasswordSet(data) {
  return request({
    url: "/loginApi/user/rPassword",  //接口路径
    method: "put",  //接口方法
    data
  });
}




